import { CheckmarkStarburstFilled } from "@fluentui/react-icons";
import { Column } from "./Layout";
import React, { useState } from "react";
import { Button, Image, Input, Dropdown, Option } from "@fluentui/react-components";
import linkIcon from "../../../assets/icons/ic_link.svg";

export const HandleSelectBrowser = (url: string, browser: string) => {
    const isAndroid = /android/i.test(navigator.userAgent)
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)
    const isSamsungBrowser = /samsung/i.test(navigator.userAgent)
    const isNaverBrowser = /naver/i.test(navigator.userAgent)

    const isChrome = isIOS
        ? /crios/i.test(navigator.userAgent)
        : /chrome/i.test(navigator.userAgent) &&
        !isSamsungBrowser &&
        !isNaverBrowser

    const intentUrl = url.replace(/^https?:\/\//, '')

    const intentUrls = {
        Samsung: `intent://${intentUrl}#Intent;scheme=https;package=com.sec.android.app.sbrowser;S.browser_fallback_url=${encodeURIComponent(url)};end`,
        Naver: `intent://inappbrowser?url=${encodeURIComponent(url)}&version=1#Intent;scheme=naversearchapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.search;end;`,
        Chrome: `intent://${intentUrl}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`,
    }

    const iosUrls = {
        Chrome: `googlechrome://${url.replace(/^https?:\/\//, '')}`,
        Naver: `naversearchapp://inappbrowser?url=${encodeURIComponent(url)}`,
    }

    if (isChrome && browser === 'Chrome') {
        alert("<isChrome && Chrome>  " + "url: " + url)
        window.open(url, '_blank')
        return
    }

    if (isSamsungBrowser && browser === 'Samsung') {
        alert("<isSamsungBrowser && Samsung>  " + "url: " + url)
        window.open(url, '_blank')
        return
    }

    if (isNaverBrowser && (browser === 'Naver' || browser === 'Default' || browser === 'Samsung' || browser === 'Safari')) {
        if (isAndroid) {
            alert("<3>  " + "url: " + intentUrls['Chrome'])
            window.open(intentUrls['Chrome'],'_blank')
        } else if (isIOS) {
            alert("<4>  " + "url: " + iosUrls['Naver'])
            window.open(iosUrls['Naver'],'_blank')
        }
        return
    }

    if (isAndroid) {

        const selectedintentUrl = intentUrls[browser as keyof typeof intentUrls] || url
        alert("<5>  " + "url: " + selectedintentUrl)
        window.open(selectedintentUrl, '_blank')

        if (isNaverBrowser) {
            alert("<6>  " + "url: " + intentUrls['Naver'])
            window.open( intentUrls['Naver'])
        } else {
            setTimeout(() => {
                alert("<7>  " + "url: " + url)
                window.open(url, '_blank')
            }, 1000);
        }

    } else if (isIOS) {

        const selectedIosUrl = iosUrls[browser as keyof typeof iosUrls] || url
        alert("<8>  " + "url: " + selectedIosUrl)
        window.open(selectedIosUrl, '_blank')

        if (isNaverBrowser) {
            alert("<9>  " + "url: " + iosUrls['Naver'])
            window.open(iosUrls['Naver'])
        } else {
            setTimeout(() => {
                alert("<10>  " + "url: " + url)
                window.open(url, '_blank')
            }, 1000);
        }

    } else {
        alert("<11>  " + "url: " + url)
        window.open(url, '_blank')
    }
}

export default function TestPage() {
    const [url, setUrl] = useState('');
    const [browser, setBrowser] = useState('Default');

    return (
        <Column gap={'16px'} alignItems={'center'} justifyContent={'center'} style={{ marginTop: '96px' }}>
            <CheckmarkStarburstFilled fontSize={'200px'} color={'black'} />

            <Input
                placeholder="URL 입력"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                style={{ width: 300 }}
            />

            <Dropdown
                placeholder="브라우저 선택"
                value={browser}
                onOptionSelect={(e, data) => setBrowser(data.optionValue!)}
                style={{ width: 300 }}
            >
                <Option value="Default">Default</Option>
                <Option value="Chrome">Chrome</Option>
                <Option value="Safari">Safari</Option>
                <Option value="Samsung">Samsung</Option>
                <Option value="Naver">Naver</Option>
            </Dropdown>

            <Button
                icon={<Image alt={"링크 아이콘"} src={linkIcon} width={15} height={15} />}
                onClick={() => HandleSelectBrowser(url, browser)}
            >
                테스트
            </Button>
        </Column>
    );
}
